import { ReactElement, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Badge, ButtonProps } from 'antd';

import AntdFeatherIcon from '../AntdFeatherIcon';

import './style.less';

interface AppHeaderButtonProps extends ButtonProps {
  icon: ReactNode;
  children?: ReactNode;
  showBadge?: boolean;
  countBadge?: number;
}

const AppHeaderButton = ({
  icon,
  children = null,
  showBadge = false,
  countBadge,
  ...buttonProps
}: AppHeaderButtonProps) => (
  <button
    {...buttonProps}
    type="button"
    className={`header-button ${buttonProps.className}`}
  >
    <Badge dot={showBadge} count={countBadge} overflowCount={99} size="small">
      <AntdFeatherIcon icon={icon as ReactElement} size={20} />
    </Badge>

    {children}
  </button>
);

AppHeaderButton.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default AppHeaderButton;
